import { FC } from 'react'
import { Address } from 'graphql/types'
import { TUser } from '../types'
import { getFullAddress } from 'lib/listing'
import { IconCheck, IconClock, IconCross, IconHouse } from 'icons'
import Button from 'components/Button'
import FeatureItem from 'components/FeatureItem'
import Result from 'components/Result'
import Typography from 'components/Typography'
import styles from './Confirmation.module.scss'

export type TProps = {
  status: 'success' | 'error'
  data: {
    day: string
    month: string
    weekDay: string
    hour: string
    min: string
    address: Address
  }
  profile?: TUser
  setStep: (step: number) => void
  onSuccessButtonClick: () => void
}

const Confirmation: FC<TProps> = ({
  status,
  data,
  setStep,
  profile,
  onSuccessButtonClick,
}) => {
  const FeedbackStatus = {
    success: {
      IconComponent: IconCheck,
      title: 'Agendamento solicitado! Confirmaremos em breve',
      text: 'Em breve, enviaremos uma mensagem via WhatsApp ou te ligaremos para passar mais informações.',
      content: (
        <div className={styles.ecConfirmationVisitInfo}>
          <FeatureItem
            Icon={{
              Component: IconClock,
              color: 'grey900',
              title: 'Horário agendado',
            }}
            title={`${data.day}/${data.month} ${data.weekDay}, às ${data.hour}:${data.min}`}
          />
          <FeatureItem
            Icon={{
              Component: IconHouse,
              color: 'grey900',
              title: 'Endereço da visita',
            }}
            title={getFullAddress(data)}
          />
        </div>
      ),
    },
    error: {
      IconComponent: IconCross,
      title: 'Ocorreu um erro ao receber os seus dados',
      text: 'Tente enviá-los novamente ou entre em contato com a nossa equipe',
      content: (
        <>
          <Button theme="pink" onClick={() => setStep(2)}>
            Tentar novamente
          </Button>
          <Button
            href={String(
              `mailto:contato@emcasa.com?subject=${encodeURIComponent(
                'EmCasa - Erro ao enviar Agendamento de Visita',
              )}`,
            )}
          >
            Entrar em contato
          </Button>
        </>
      ),
    },
  }

  const getStatus = () => {
    return FeedbackStatus[status]
  }

  return (
    <div>
      <Result
        Icon={{
          Component: getStatus().IconComponent,
          color: 'grey900',
          title: getStatus().title,
        }}
        title={getStatus().title}
        text={getStatus().text}
        status={status}
      >
        <div className={styles.ecConfirmationContent}>
          {getStatus().content}
          {status === 'success' && profile && !profile?.hasSearchPreferences && (
            <>
              <Typography variant="TitleSmall" bold>
                Receba recomendações de imóvel
              </Typography>
              <Typography>
                Conte o que você está procurando e enviaremos opções ideais para
                o seu perfil via email e WhatsApp.
              </Typography>
              <Button theme="pink" onClick={onSuccessButtonClick}>
                Quero receber mais imóveis
              </Button>
            </>
          )}
        </div>
      </Result>
    </div>
  )
}

export default Confirmation
